import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import productPageLinkTracking from 'analytics/bindings/pages/product/productPageLinkTracking';
import helpersUtils from 'utils/Helpers';

const { deferTaskExecution } = helpersUtils;

let hasFired = false;

const fireOnce = () => {
    if (hasFired) {
        return;
    }

    hasFired = true;
    deferTaskExecution(() => {
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: productPageLinkTracking.altImageSwipeBindings()
        });
    });
};

const reset = () => {
    hasFired = false;
};

export default {
    fireOnce,
    reset
};
